import { useMemo, useState } from "preact/hooks";
import { GameIcon } from "./casino-contents";
import * as I from "../../utils/icons";
import { Carousel } from "./carousel";
import { CasinoPagesInfo, InfiniteScrollPage } from "./casino-components";
import { CasinoRetriever, CasinoWidget, pageInfoFromUrl, useCasinoSlots, getGameRowUrl, useGamesRow, LegacyCasinoRetriever, useCasinoProviders, NextCasinoRetriever, useCasinoPageInfo } from "./logic";
import { route } from "preact-router";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { CasinoSearchPopup } from "./casino-search-popup";

// Qui: una classe che gestisca il "casino multipage".
// Il casino multipage è un componente che riceve una path come:
// "/{virtual|special-games}/{p|c}?/{providerCode|categoryCode}?"
// In base alla path decide quale pagina costruire.
// Se c'è solo il primo token, disegna una "casino home" con la configurazioen in "pages"
// Se c'è anche il secondo e terzo token, disegna una pagina con infinite scroll con tutti i giochi del "gruppo".

export function DesktopCasinoMultiPage({ path, type, pageCode }) {
    if (path == '/casino') {
        route('/virtual');
        return;
    }
    const pagesInfo = useCasinoPageInfo()
    if (pagesInfo == null)
        return null;
    const slots = useCasinoProviders();
    const gamesRetriever = useMemo(() => new NextCasinoRetriever(slots), [slots]);
    const mainPage = path.split('/')[1];
    const pageTypeInfo = pagesInfo.getPage(mainPage);

    return <div class="flex">
        <div class="menu-column w-64 bg-harif-950 p-2 flex-none flex flex-col gap-1">
            <div class="bg-harif-800 rounded-md p-2">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <I.FavouritesIcon class="w-5 h-5" />
                        <div>
                            <div class="font-bold">{pageTypeInfo.name}</div>
                            <div class="text-xs text-slate-400"><Trans>Chck out our games!</Trans></div>
                        </div>
                    </div>
                    <I.UpArrowIcon class="w-5 h-5" />
                </div>
            </div>
            <div
                class="bg-harif-800 text-sm rounded-md p-2 flex items-center gap-2 hover:bg-harif-800/50 cursor-pointer"
                onClick={(e) => (window.location.hash = CasinoSearchPopup.CASINO_SEARCH_HASH)}
            >
                <I.SearchIcon class="w-4 h-4" />
                <div><Trans>Search</Trans></div>
            </div>
            {pageTypeInfo.rows.map(widget => (
                <div
                    onClick={() => route(getGameRowUrl(widget, mainPage))}
                    class="bg-harif-800 text-sm rounded-md p-2 flex items-center gap-2 hover:bg-harif-800/50 cursor-pointer"
                >
                    <I.FavouritesIcon class="w-4 h-4" />
                    <div>{widget.data.name}</div>
                </div>
            ))}
        </div>
        <div class="flex-grow min-w-0 bg-harif-800 text-white">
            {type == null
                ? <DesktopWidgets key={path} mainPage={mainPage} page={pageTypeInfo.rows} games={gamesRetriever} />
                : <InfiniteScrollPage key={path} games={gamesRetriever} currentPage={pageInfoFromUrl(type, pageCode, pagesInfo)} mainPage={mainPage} />}
        </div>
        <CasinoSearchPopup />
    </div>
}

export function DesktopWidgets({ page, games, mainPage }: { page: CasinoWidget[], games: CasinoRetriever, mainPage: string }) {
    return <div class="main-content">
        <Carousel />
        {page.map(widget => <DesktopGamesRow page={widget} games={games} mainPage={mainPage} />)}
    </div>;
}

export function DesktopGamesRow({ page, games, mainPage }: { page: CasinoWidget, games: CasinoRetriever, mainPage: string }) {
    const { scrollPrev, scrollNext, emblaRef, chunkedGames } = useGamesRow(page.data.cols, page.data.rows, games, page);
    const url = getGameRowUrl(page, mainPage);

    if (chunkedGames.length == 0)
        return null;

    return <div class="pt-4 pb-2">
        <div class="flex items-center justify-between px-4 py-4 pt-2">
            <a href={url} class="text-lg">{page.data.name}</a>
            <div class="flex items-center gap-2">
                <a href={url} class="text-sm text-slate-400">See More</a>
                <button onClick={scrollPrev} class="w-8 h-8 rounded-full bg-harif-900 flex items-center justify-center">
                    <I.AnglesLeft class="h-4" />
                </button>
                <button onClick={scrollNext} class="w-8 h-8 rounded-full bg-harif-900 flex items-center justify-center">
                    <I.AnglesRight class="h-4" />
                </button>
            </div>
        </div>
        <div class="overflow-hidden" ref={emblaRef}>
            <div class="flex">
                {chunkedGames.map((chunk, i) => (
                    <div class="flex-shrink-0 w-full min-w-0 px-2" key={i}>
                        <div class={`grid grid-cols-${page.data.cols} gap-2`}>
                            {chunk.map(game => <GameIcon game={game} />)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>;
}
